<template>
     <div :style="cssProps" :class="[{ 'attachments-grid': !isMobile }]">
            <template v-if="!isMobile">
                <div class="attachments">
                    <eg-attachment-reader
                        v-for="(attachment, index) in attachments"
                        class="attachment"
                        :key="index"
                        :index="index"
                        :name="attachment.file_name"
                        deletable
                        @delete="removeAttachment($event)"
                    ></eg-attachment-reader>
                </div>
            </template>
            <template v-else>
                <div>
                    <eg-attachment-reader
                        v-for="(attachment, index) in attachments"
                        class="attachment"
                        :key="index"
                        :index="index"
                        :name="attachment.file_name"
                        deletable
                        @delete="removeAttachment($event)"
                    ></eg-attachment-reader>
                </div>
            </template>
            <input
                @change="convertFileToBase64($event)"
                class="attachment"
                type="file"
                accept=""
                :name="attachmentsId"
                :id="attachmentsId"
                multiple
            />
            <label :for="attachmentsId" class="attachments-btn"
                ><i class="fas fa-paperclip attachment-icon"></i>Anexar</label
            >
    </div>
</template>

<script>
export default {
    data: () => ({
        attachments: [],
        isMobile: false
    }),
    props: {
        attachmentsId: {
            type: String,
            default: 'attachments'
        },
        clearAttachments: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        clearAttachments(){
            this.clearAllAttachments()
        }
    },
    methods: {
        convertFileToBase64(event) {
            const self = this;
            for (const file of event.target.files) {
                const reader = new FileReader();
                reader.onload = function(e) {
                    self.isFileValid = self.validateAttachmentSize(file);
                    self.isFileLoading = false;
                    if (self.isFileValid) {
                        self.attachments.push({
                            file: e.target.result,
                            file_name: file.name
                        });
                        self.$emit('update', self.attachments);
                    }
                };
                reader.onerror = function(error) {
                    console.error(error);
                    self.isFileLoading = false;
                };

                if (file) {
                    self.isFileLoading = true;
                    reader.readAsDataURL(file);
                }
            }
        },
        validateAttachmentSize(file) {
            const maximumFileSizeInMegabytes = 25;
            const fileSizeInMegabytes = file.size / 1024 / 1024;
            return fileSizeInMegabytes <= maximumFileSizeInMegabytes;
        },
        removeAttachment(index) {
            this.attachments.splice(index, 1);
            this.$emit('update', this.attachments);
        },
        clearAllAttachments(){
            this.attachments = [];
        }
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    computed: {
        cssProps() {
            return {
                '--paddingAttachement': !this.attachments.length ? '18px' : '5px'
            };
        }
    }
};
</script>

<style lang="scss" scoped>
input[type='file'] {
    display: none;
}
.attachments::-webkit-scrollbar {
    width: 10px; /* width of the entire scrollbar */
}

.attachments::-webkit-scrollbar-track {
    background: #fff; /* color of the tracking area */
}

.attachments::-webkit-scrollbar-thumb {
    background-color: #dbdbdb; /* color of the scroll thumb */
    border-radius: 10px; /* roundness of the scroll thumb */
    border: 2px solid #fff; /* creates padding around scroll thumb */
}
.attachments-btn {
    font-size: 16px;
    font-weight: 600;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    display: flex;
    background-color: #dbdbdb;
    border: 1px solid #dbdbdb;
    color: #707070;
    width: 23%;
    min-height: 50px;
    height: auto;
    justify-content: center;
    align-items: center;
}
.attachments-btn:hover {
    background-color: #c3c3c3;
}
.attachment-icon {
    margin-right: 5px;
}
.attachments-grid {
    display: flex;
}
.attachments {
    padding: var(--paddingAttachement);
    border: 2px solid #dbdbdb;
    /* padding: 5px; */
    display: -webkit-box;
    /* flex-wrap: wrap; */
    overflow-y: auto;
    justify-content: start;
    /* margin-bottom: 15px; */
    width: 85%;
    max-width: 85%;
}
.attachments .attachment {
    margin-right: 15px;
    margin-bottom: 1px;
    margin-top: 1px;
}
@media screen and (max-width: 992px) {
    .attachments-btn {
        margin-top: 10px;
        width: 100%;
        height: 40px;
        font-size: 20px;
    }
    .attachment {
        margin-top: 10px;
    }
}
</style>
